import * as actions from './actionTypes';
import { createRoutine } from 'redux-saga-routines';
export const bootstrapEvent = createRoutine('BOOTSTRAP_EVENT');

export const setEventsLoaded = (payload: boolean) => {
    return { type: actions.SET_EVENTS_LOADED, payload };
};

export const setActiveEvent = (event_id: string) => {
    return { type: actions.SET_ACTIVE_EVENT, event_id };
};

export const setSidebar = (status: boolean, clicked?: boolean) => {
    return { type: actions.SET_SIDEBAR, status, clicked };
};
export const setChannelEditing = (channel_id: boolean) => {
    return { type: actions.SET_CHANNEL_EDITING, channel_id };
};
export const setChannelActive = (channel_id: boolean) => {
    return { type: actions.SET_CHANNEL_ACTIVE, channel_id };
};
export const clearActiveChannel = (channel_id: boolean) => {
    return { type: actions.CLEAR_ACTIVE_CHANNEL, channel_id };
};
export const clearForm = (channel_id: boolean) => {
    return { type: actions.CLEAR_ACTIVE_CHANNEL, channel_id };
};
export const setActiveMoment = (moment_id: boolean) => {
    return { type: actions.SET_ACTIVE_MOMENT, moment_id };
};
export const setExpandedDiscover = (discover_id: number, expanded: boolean) => {
    return { type: actions.SET_EXPANDED_DISCOVER, discover_id, expanded };
};
export const setActiveNotification = (notification_id: string) => {
    return { type: actions.SET_ACTIVE_NOTIFICATION, notification_id };
};
export const setActiveDiscover = (discover_id: string, location: string, parent_list?: string) => {
    return { type: actions.SET_ACTIVE_DISCOVER, discover_id, location, parent_list };
};
